export default "/images/fincity-logo.png?911cd6ec250c3230932e673abfeba7e7";